import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { DocumentGenerationParamsUpdateStore } from "../../store";
import { InputDate } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type DocumentGenerationParamsUpdateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  contractEffectiveDate: string | null;
  contractEffectiveDateSelectedValue?: { displayId: string; id: string } | null;
  onContractEffectiveDateChange?: (value: string | null) => void;
  contractEffectiveDateError?: string;
  contractEndDate: string | null;
  contractEndDateSelectedValue?: { displayId: string; id: string } | null;
  onContractEndDateChange?: (value: string | null) => void;
  contractEndDateError?: string;
  documentGenerationParamsUpdateStore: DocumentGenerationParamsUpdateStore;
};

export const DocumentGenerationParamsUpdateForm: React.FC<DocumentGenerationParamsUpdateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      contractEffectiveDate = null,
      contractEffectiveDateError,
      onContractEffectiveDateChange = () => {},
      contractEndDate = null,
      contractEndDateError,
      onContractEndDateChange = () => {},
      documentGenerationParamsUpdateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelUpdatedEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="DocumentGenerationParams"
              mode="update"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "contractEffectiveDate":
                    onContractEffectiveDateChange?.(valor);
                    break;
                  case "contractEndDate":
                    onContractEndDateChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={documentGenerationParamsUpdateStore.getCardErrors(
                "null"
              )}
              title={langStore.groupDocumentGenerationParamsLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputDate
                  autoFocus
                  value={contractEffectiveDate}
                  error={Boolean(contractEffectiveDateError)}
                  warning={
                    !contractEffectiveDateError &&
                    Boolean(
                      documentGenerationParamsUpdateStore.warnings[
                        "contractEffectiveDate"
                      ]
                    )
                  }
                  helperText={
                    contractEffectiveDateError ||
                    documentGenerationParamsUpdateStore.warnings[
                      "contractEffectiveDate"
                    ]?.message
                  }
                  label={
                    langStore.DocumentGenerationParamsContractEffectiveDateLabel
                  }
                  description={
                    langStore.DocumentGenerationParamsContractEffectiveDateDescription
                  }
                  onChange={(value: string | null | null) =>
                    onContractEffectiveDateChange(value)
                  }
                />
                <InputDate
                  value={contractEndDate}
                  error={Boolean(contractEndDateError)}
                  warning={
                    !contractEndDateError &&
                    Boolean(
                      documentGenerationParamsUpdateStore.warnings[
                        "contractEndDate"
                      ]
                    )
                  }
                  helperText={
                    contractEndDateError ||
                    documentGenerationParamsUpdateStore.warnings[
                      "contractEndDate"
                    ]?.message
                  }
                  label={langStore.DocumentGenerationParamsContractEndDateLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.DocumentGenerationParamsContractEndDateDescription
                  }
                  onChange={(value: string | null | null) =>
                    onContractEndDateChange(value)
                  }
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
